<template>
  <div class="reset-pwd">
    <h3>修改资料</h3>
    <div class="info">
      <el-form ref="form" :model="form" label-width="170px" :rules="formRules">
        <el-form-item v-for="(field, index) in currentFields" :key="`${field.key}-${index}`" :label="field.label" :prop="field.key">
          <!-- 文本输入带按钮 -->
          <template v-if="field.type === 'text' && field.btnStyle">
            <el-input v-model="form[field.key]" :readonly="field.readonly" :disabled="field.readonly"
              style="width: 200px; margin-right: 12px" />
            <!-- 普通按钮 -->
            <el-button v-if="field.btnStyle == 'changeType'" class="btn" type="info" @click="TextBtn(field.keyBtnType)"
              :disabled="bankCardPhoneFlag">
              更改
            </el-button>
            <!-- 手机验证码 -->
            <!-- <el-button v-else class="btn" type="info" @click="getPhoneSmsCode(field.phone,field.keyBtnType,field.smsCodeType)" :disabled="flag">{{ flag ? `（${current}） s` : "发送验证码"
          }}</el-button> -->

          </template>

          <!-- 其他文本输入 -->
          <el-input v-else-if="field.type === 'text'" v-model="form[field.key]" :readonly="field.reasdonly"
            :disabled="field.readonly" @input="inputOninput($event)" />

          <!-- 级联选择 -->
          <el-cascader v-else-if="field.type === 'cascader'" style="width: 100%;" v-model="form[field.key]"
            :options="field.cityOptions" :show-all-levels="true" clearable />

          <!-- 双级联选择器（农资供应商/新型经营主体）field.props1 -->

          <div v-else-if="field.type === 'double-cascader'" style="display: flex; gap: 8px; align-items: center;">
            <el-cascader ref="XgzlFirst" :options="options" :props="props" style="width: 49%; margin-right: 2%"
              @change="cityChange" v-model="value" emitPath="false"></el-cascader>
            <el-cascader ref="XgzlSecond" emitPath="false" :options="options2" :props="props" style="width: 49%"
              @change="roadChange" v-model="value2"></el-cascader>
            <div class="el-form-item__error" v-show="areaHasChild" style="color: #f56c6c; font-size: 12px;">请选到最后一级
            </div>
          </div>

          <!-- 营业执照上传（仿nzgys.vue） -->
          <template v-else-if="field.type === 'image' && field.style === 'businessLicense'">
            <el-upload class="upload-demo" action="" :on-change="uploadYyzz" :on-remove="removeYyzz"
              :accept="'.jpg,.jpeg,.gif,.png,.pdf'" :limit="1" :auto-upload="false" name="营业执照" list-type="picture-card"
              :file-list="form.businessLicense ? form.businessLicense : []">
              <el-button v-if="uploading == 0" size="small" type="primary">点击上传</el-button>
              <el-button v-else-if="uploading == 1" size="small" type="primary" :loading="true"
                style="display: inline-flex;justify-content: center;align-items: center;">上传中...</el-button>
              <el-button v-else-if="uploading == 2" size="small" type="primary" :loading="true"
                style="display: inline-flex;justify-content: center;align-items: center;">努力识别中</el-button>
              <div slot="tip" class="el-upload__tip" style="margin-top: -6px">上传图片最大6M，支持：JPG/JPEG/GIF/PNG/PDF格式。</div>
            </el-upload>
          </template>

          <!-- 法人身份证人像面上传（仿nzgys.vue） -->
          <template v-else-if="field.type === 'image' && field.style === 'card'">
            <div class="upload">
              <div class="upload-box">
                <el-upload v-loading="loadingFront" :element-loading-text="'上传中...'" ref="front" action=""
                  :auto-upload="false" :show-file-list="false" name="files"
                  :on-change="(file) => { handleChange(file, '0'); }" :disabled="field.uploadDisabled">
                  <template v-if="!loadingFront">
                    <img slot="default"
                      :src="imgUrl[0] ? baseUrl + 'admin/file/get?ossFilePath=' + imgUrl[0] : 'imgs/card-1.png'"
                      alt="" />
                  </template>
                  <template v-else>
                    <el-button size="small" type="primary" :loading="true">上传中...</el-button>
                  </template>
                </el-upload>
              </div>
            </div>
          </template>

          <!-- 法人身份证国徽面上传（仿nzgys.vue） -->
          <template v-else-if="field.type === 'image' && field.style === 'cardBack'">
            <div class="upload">
              <div class="upload-box">
                <el-upload v-loading="loadingBack" :element-loading-text="'上传中...'" ref="back" action=""
                  :auto-upload="false" :show-file-list="false" list-type="picture-card" :limit="1" name="files"
                  :on-change="(file) => { handleChange(file, '1'); }" :disabled="field.uploadDisabled">
                  <template v-if="!loadingBack">
                    <img :src="imgUrl[1] ? baseUrl + 'admin/file/get?ossFilePath=' + imgUrl[1] : 'imgs/card-2.png'"
                      alt="" />
                  </template>
                  <template v-else>
                    <el-button size="small" type="primary" :loading="true">上传中...</el-button>
                  </template>
                </el-upload>
              </div>
            </div>
            <p style="color: #ff6633; margin: 0">(特别提示：照片必须将身份证四个边框完整拍入)</p>
          </template>

          <!-- 其他图片上传（保持原有） -->
          <template v-else-if="field.key === 'companyPhoto'">
            <el-upload class="upload-demo" action="" :before-upload="beforeUpload2" :on-change="uploadImages"
              :on-remove="removeImages" :accept="'.jpg,.jpeg,.gif,.png'" multiple :limit="6" :auto-upload="false"
              :file-list="form.companyPhoto" list-type="picture-card">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip" style="margin-top: -6px">
                单张图片最大6M，最多上传6张，支持:JPG/JPEG/GIF/PNG格式。
              </div>
            </el-upload>
          </template>
          <el-upload v-else-if="field.type === 'image'" :action="''" :accept="field.accept" :auto-upload="false"
            :limit="field.multiple ? 5 : 1" :multiple="field.multiple" :file-list="form[field.key]"
            list-type="picture-card">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>

          <!-- 其他类型可继续扩展 -->
        </el-form-item>
      </el-form>
      <el-button type="success" @click="submit">确认修改</el-button>
    </div>
    <!-- 弹窗 -->
    <el-dialog title="修改手机" :visible.sync="showChangeTel" width="510px" @close="resetTelCountdown">
      <el-form :model="editForm" label-width="120px" :rules="ruleTel" ref="editForm">
        <el-form-item label="新手机号码" prop="mobile">
          <el-input v-model="editForm.mobile" style="width: 200px; margin-right: 12px"
            @input="inputOninput($event)"></el-input>
          <el-button class="btn" type="info" @click="getTelCode" :disabled="flag">{{ flag ? `（${current}） s` : "发送验证码"
            }}</el-button>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input v-model="editForm.smsCode" style="width: 200px" @input="inputOninput($event)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -12px">
        <el-button @click="showChangeTel = false">取 消</el-button>
        <el-button type="primary" @click="changeTel">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改银行卡" :visible.sync="showChangeBank" width="510px" @close="handleBankDialogClose">
      <el-form :model="editFormBank" label-width="120px" :rules="editFormBankRule" ref="editFormBank">
        <el-form-item label="银行卡" prop="bankCardId">
          <el-input v-model="editFormBank.bankCardId" @input="bankAffiliatedBankChange($event)"
            style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="所属银行" prop="affiliatedBank">
          <el-input v-model="editFormBank.affiliatedBank" style="width: 200px" @input="inputOninput($event)"></el-input>
        </el-form-item>
        <el-form-item label="银行预留手机号" prop="bankCardPhone">
          <el-input v-model="editFormBank.bankCardPhone" style="width: 200px" @input="inputOninput($event)"></el-input>
        </el-form-item>
        <el-form-item label="银行短信验证码" prop="smsCode">
          <el-input v-model="editFormBank.smsCode" style="width: 200px; margin-right: 12px"
            @input="inputOninput($event)"></el-input>
          <el-button class="btn" type="info" @click="getUserCode" :disabled="flag2">{{ flag2 ? `（${current2}） s` :
            "发送验证码" }}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -12px">
        <el-button @click="showChangeBank = false">取 消</el-button>
        <!-- changeUser -->
        <el-button type="primary" @click="submitBankId">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改联系人" :visible.sync="showChangePeople" width="510px" @close="handleBankDialogClose">
      <el-form :model="editFormPeople" label-width="120px" :rules="editFormPeopleRule" ref="editFormPeople">
        <el-form-item label="姓名" prop="contactName">
          <el-input v-model="editFormPeople.contactName" @input="inputOninput($event)"
            style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="editFormPeople.contactCard" style="width: 200px" @input="inputOninput($event)"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="editFormPeople.contactPhone" style="width: 200px" @input="inputOninput($event)"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码" prop="codeSms">
          <el-input v-model="editFormPeople.codeSms" style="width: 200px; margin-right: 12px"
            @input="inputOninput($event)"></el-input>
          <el-button class="btn" type="info" @click="getUserCode4" :disabled="flag2">{{ flag2 ? `（${current2}） s` :
            "发送验证码" }}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -12px">
        <el-button @click="showChangePeople = false">取 消</el-button>
        <!-- changeUser -->
        <el-button type="primary" @click="submiteditFormPeople">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSmsCodeNew } from "@/api/certificate";
import {
  changeLoginPhone,
  changeContract,
  getXzqArr,
  changeUserInfo,
  getUserNow,
  getUserMenuByIdentity,
  getIdentityList,
} from "@/api/add";
import { mapGetters } from "vuex";
import { removeEmptyChildren } from "@/js/utils/util";
import identityConfig from './identityConfig'
import { uploadFile, deleteFile } from "@/api/fileApi";
import { bankCardAttribution } from "./index";
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error("密码长度在6~32个字符之间"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error("密码长度在6~32个字符之间"));
      } else {
        callback();
      }
    };
    return {
      editFormPeople: {

      },//修改联系人
      editFormPeopleRule: {
        contactName: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        contactCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        codeSms: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      showChangePeople: false,
      editFormBank: {

      },//修改银行卡
      editForm: {
        mobile: '', // 新手机号（修改时填写）
        smsCode: '', // 手机验证码
      },//修改弹窗表单
      keyForm: 0,
      regionOptions: [{}],
      // companyAddress: [],
      baseUrl: window.globalUrl.BASE_API,

      props: {
        label: "areaName",
        children: "children",
        value: "id",
        fullPathName: "fullPathName",
        checkStrictly: true,
        emitPath: false,
        expandTrigger: "hover",
      },


      form: {},
      ruleTel: {
        mobile: [{ required: true, message: "请输入新手机号码", trigger: "blur" }],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      editFormBankRule: {
        bankCardId: [
          { required: true, message: "请输入银行卡号", trigger: "blur" },
        ],
        affiliatedBank: [
          { required: true, message: "请输入所属银行", trigger: "blur" },
        ],
        bankCardPhone: [
          { required: true, message: "请输入银行预留手机号", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      flag: false,
      flag2: false,
      max: 60,
      current: 60,
      current2: 60,
      showChangeBank: false,
      showChangeTel: false,
      flag1: false,

      formRule: {
        oldPwd: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z][a-zA-Z0-9]{7,17}$/,
            message: "以字母开头，长度在8~18之间，只能包含字母和数字",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        newPwd2: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z][a-zA-Z0-9]{7,17}$/,
            message: "以字母开头，长度在8~18之间，只能包含字母和数字",
            trigger: "blur",
          },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      options: [],
      options2: [],
      value: '',
      value2: '',
      areaHasChild: false,
      bankCardPhoneFlag: false,
      bankCardPhoneMax: 60,
      bankCardPhoneCurrent: 60,
      uploading: 0,
      loadingFront: false,
      loadingBack: false,
      lo: 0,
      imgUrl: ['', ''],
      uploadDisabled: false,
      imgInfo: [undefined, undefined], // 存储上传返回的图片路径
      fileList: [],
      fileList1: [],
      businessLicenseUrl: '', // 新增字段，追踪营业执照原始路径
      imagesIds: [],
      imagesInfos: [],
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'identityObj']),
    currentFields() {
      let config = identityConfig.find(item => item.type == this.identityObj.identityTypeCode)
      // 如果没有找到对应的配置，则取identityConfig数组的最后一个元素
      if (!config) {
        // config = identityConfig[identityConfig.length - 1];
        config=identityConfig.find(item => item.type == 'error')
      }
      // 当身份类型为 2（个人）时，将 userName 同步到 sysUserAuth.userName。
      // 由于部分情况下 sysUserAuth 可能为 null，需先进行空值判断，防止 "Cannot set properties of null" 错误。
      if (this.identityObj.identityTypeCode == 2 && this.identityObj.sysUserAuth) {
        this.identityObj.sysUserAuth.userName = this.identityObj.userName
        // this.editFormBank.realName=this.identityObj.userName
        // this.identityObj.sysUserAuth.bossCardId=this.identityObj.bossCardId
      } else if (this.identityObj.identityTypeCode == 4 && this.identityObj.sysCompanyAuth) {
        this.identityObj.sysCompanyAuth.userName = this.identityObj.userName
      }
      // 将fields的key替换为form中存在的字段名用于初始化
      return config.fields.map(field => {
        // 查找form中是否有与field.key同名的字段
        if (this.form && Object.prototype.hasOwnProperty.call(this.form, field.key)) {
          return field;
        } else {
          // 如果form中没有该字段，保持原样
          return field;
        }
      });
    },
    formRules() {
      const baseRules = this.formRule ? { ...this.formRule } : {};
      const config = identityConfig.find(item => item.type == this.identityObj.identityTypeCode);
      if (!config) return baseRules;

      config.fields.forEach(field => {
        if (field.rules) {
          baseRules[field.key] = field.rules;
        } else if (field.required) {
          // 2. 如果仅标记了 required，根据字段类型自动选择触发方式
          const rule = {
            required: true,
            message: `请输入${(field.label || '').replace(/[：:]/, '')}`,
            trigger: (['image', 'cascader', 'double-cascader'].includes(field.type) ? 'change' : 'blur')
          };
          // 图片上传 el-upload 返回数组，需指定 type
          if (field.type === 'image') {
            rule.type = 'array';
            rule.message = `请上传${(field.label || '').replace(/[：:]/, '')}`;
          }
          baseRules[field.key] = [rule];
        }
      });

      return baseRules;
    }
  },
  watch: {
    'identityObj.identityTypeCode': {
      handler(newVal) {
        this.echoIdentityObj();
      },
      immediate: true
    },
    options(newVal) {
      if (Array.isArray(newVal) && newVal.length > 0) {
        // 正确访问方式
        // newVal[0].level
      }
    }
  },
  mounted() {
    this.getRegions();
    this.echoIdentityObj()
  },
  methods: {
    //修改银行输入卡号回显队形的所属银行
    bankAffiliatedBankChange(val) {
      this.$forceUpdate()
      console.log(val)
      const obj = bankCardAttribution(this.editFormBank.bankCardId)
      // console.log(obj,'查看obj')
      if (this.editFormBank.bankCardId.length >= 5) {
        if (obj != "error") {
        this.editFormBank.affiliatedBank = obj.bankName;
      } else {
        this.editFormBank.affiliatedBank = "";
      }
      }else{
        this.editFormBank.affiliatedBank = '';
      }
     
    },
    //所有修改按钮的方法
    TextBtn(type) {
      switch (type) {
        //修改手机号
        case 'NhphoneType':
          // this.editForm.userName = this.identityObj.userName
          this.editForm.smsCode = ""
          this.editForm.mobile = this.identityObj.userName
          this.showChangeTel = true
          break;
        // 修改银行卡
        case 'NhbankCardIdType':
          // 预填充值行银行卡信息，并清空验证码
          this.editFormBank = {
            bankCardId: this.form.bankCardId || '',
            affiliatedBank: this.form.affiliatedBank || '',
            bankCardPhone: this.form.bankCardPhone || '',
            smsCode: ''
          };
          // 打开修改银行卡弹窗
          this.showChangeBank = true;

          // 自动发送验证码（若银行预留手机号存在）
          console.log(this.editFormBank, '查看是否附上值')
          this.showChangeBank = true
          break;
        //修改联系人
        case 'fourContactName':
          this.editFormPeople = {
            contactName: this.form.contactName || '',
            contactCard: this.form.contactCard || '',
            contactPhone: this.form.contactPhone || '',
            codeSms: this.form.contactSmsCode || '',
        
          };
          this.showChangePeople = true
          break;


      }
    },
    inputOninput(e) {
      //直接更新视图，解决input嵌套过深的问题
      this.$forceUpdate()
    },

    //地区数据
    async getRegions() {
      // 获取地区信息
      let res = await getXzqArr({
        level: 3,
      });
      if (res.code == 0) {
        this.options = removeEmptyChildren(res.data, "children");
        // console.log(this.options, '查看获取的数据this.options')
      }
    },
    //切换组织地
    async cityChange(val) {
      // 使用 node 获取地区名并拼接
      // console.log(val,'查看val')
      const cascaderComp = Array.isArray(this.$refs.XgzlFirst) ? this.$refs.XgzlFirst[0] : this.$refs.XgzlFirst;

      const checked = cascaderComp.getCheckedNodes();
      const node = checked[0];
      // console.log(node,'查看node')
      this.value = node.value
      if (val) {
        let params = { parentCode: val };
        let res = await getXzqArr(params);
        if (res.code == 0) {
          this.value2 = null;
          // this.form.areaCode = val;

          if (res.data.length > 0) {
            this.options2 = removeEmptyChildren(res.data, "children");
            this.areaHasChild = true;
          } else {
            this.options2 = [];
            this.areaHasChild = false;
          }
        }
      }
    },
    //切换组织地后半段
    roadChange(val) {
      // console.log(this.companyAddress, '查看获取的地区')
      const cascaderComp = Array.isArray(this.$refs.XgzlSecond) ? this.$refs.XgzlSecond[0] : this.$refs.XgzlSecond;
      
      const checked = cascaderComp.getCheckedNodes();
      const node = checked[0];
      this.value2 = node.value;
      console.log(this.value2,'查看this.value2')
      this.form.areaCode = node.value
    // 为坐标赋值
      this.form.centerPoint = node.data.centerPoint
      // console.log(this.form.areaCode, '查看')

      // 判断是否为最后一级，控制提示选到最后一级
      if (node && (!node.children || node.children.length === 0)) {
        this.areaHasChild = false; // 选到最后一级，隐藏提示
      } else {
        this.areaHasChild = true;  // 不是最后一级，显示提示
      }
    },

    //修改手机弹窗确认按钮
    changeTel() {

      // console.log(this.editForm,'查看获取到的editForm')
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          let params = {
            username: this.identityObj.userName,
            mobile: this.editForm.mobile,
            smsCode: this.editForm.smsCode,
          };
          let res = await changeLoginPhone(params);
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.showChangeTel = false;
            // this.identityObj.contactPhone = this.editForm.mobile;
            // this.identityObj.userName= this.editForm.mobile
            this.getUserNow();
            this.$message.success(res.msg);
            this.$store.dispatch("LogOut").then(() => {
              // location.reload();
              this.$router.push({ name: "login" });
            });

          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    //修改银行卡
    changeUser() {
      this.$refs.editFormBank.validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.editFormBank,

          };
          let res = await changeContract(params);
          if (res.code == 0) {
            this.flag2 = false;
            this.showChangeBank = false;
            this.identityObj.contactName = this.form.username;
            this.form = {};
            this.getUserNow();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },

    // 获取手机号验证码
    async getPhoneSmsCode(phone, keyBtnType, smsCodeType) {
      let param = {
        phone: phone,
        type: smsCodeType,
      };
      switch (type == 'NhbankCardIdType') {
        case 1:
          console.log(param, '查看param')
          let res = await getSmsCodeNew(param);
          let { code, data, msg } = res;
          if (code == 0) {
            this.$message.success(
              `已向手机号为：${phone} 成功发送验证码！`
            );
            this.current2 = this.max;
            this.decreseInterval = setInterval(() => {
              if (this.current2 <= this.max && this.current2 > 0) {
                this.current2--;
                this.flag2 = true;
              } else if (this.current2 <= 0) {
                this.current2 = 0;
                this.flag2 = false;
                clearInterval(this.decreseInterval);
              }
            }, 1000);
          } else {
            this.$message.error(msg);
          }
          break;
      }



    },
    //联系人验证码
    async getUserCode2() {
      // 获取手机验证码
      if (this.editFormBank.bankCardPhone) {
        let param = {
          phone: this.editFormBank.bankCardPhone,
          type: "6",
        };
        let res = await getSmsCodeNew(param);
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success(
            `已向手机号为：${this.editFormBank.bankCardPhone} 成功发送验证码！`
          );
          this.current2 = this.max;
          this.decreseInterval = setInterval(() => {
            if (this.current2 <= this.max && this.current2 > 0) {
              this.current2--;
              this.flag2 = true;
            } else if (this.current2 <= 0) {
              this.current2 = 0;
              this.flag2 = false;
              clearInterval(this.decreseInterval);
            }
          }, 1000);
        } else {
          this.$message.error(msg);
        }
      } else {
        this.$message.error("请先输入联系电话");
      }
    },
    async getUserCode4() {
      // 获取手机验证码
      if (this.editFormPeople.contactPhone) {
        let param = {
          phone: this.editFormPeople.contactPhone,
          type: "6",
        };
        let res = await getSmsCodeNew(param);
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success(
            `已向手机号为：${this.editFormPeople.contactPhone} 成功发送验证码！`
          );
          this.current2 = this.max;
          this.decreseInterval = setInterval(() => {
            if (this.current2 <= this.max && this.current2 > 0) {
              this.current2--;
              this.flag2 = true;
            } else if (this.current2 <= 0) {
              this.current2 = 0;
              this.flag2 = false;
              clearInterval(this.decreseInterval);
            }
          }, 1000);
        } else {
          this.$message.error(msg);
        }
      } else {
        this.$message.error("请先输入联系电话");
      }

    },
    //银行验证码
    async getUserCode() {
      // 获取手机验证码
      if (this.editFormBank.bankCardPhone) {
        let param = {
          phone: this.editFormBank.bankCardPhone,
          type: "4",
        };
        let res = await getSmsCodeNew(param);
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success(
            `已向手机号为：${this.editFormBank.bankCardPhone} 成功发送验证码！`
          );
          this.current2 = this.max;
          this.decreseInterval = setInterval(() => {
            if (this.current2 <= this.max && this.current2 > 0) {
              this.current2--;
              this.flag2 = true;
            } else if (this.current2 <= 0) {
              this.current2 = 0;
              this.flag2 = false;
              clearInterval(this.decreseInterval);
            }
          }, 1000);
        } else {
          this.$message.error(msg);
        }
      } else {
        this.$message.error("请先输入联系电话");
      }
    },
    // 修改手机号获取验证码
    async getTelCode() {
      // 1. 判断是否输入手机号
      if (!this.editForm.mobile) {
        this.$message.error("请先输入新手机号码");
        return;
      }

      // 2. 判断新手机号是否与当前登录手机号一致
      if (this.editForm.mobile === this.identityObj.userName) {
        this.$message.error("请输入新手机号码"); // 与当前手机号一致，提示重新输入
        return;
      }

      // 3. 调用接口发送验证码
      let param = {
        phone: this.editForm.mobile + "",
        type: "7",
      };
      let res = await getSmsCodeNew(param);
      let { code, data, msg } = res;
      if (code == 0) {
        this.$message.success(
          `已向手机号为：${this.editForm.mobile} 成功发送验证码！`
        );
        this.current = this.max;
        this.decreseInterval = setInterval(() => {
          if (this.current <= this.max && this.current > 0) {
            this.current--;
            this.flag = true;
          } else if (this.current <= 0) {
            this.current = 0;
            this.flag = false;
            clearInterval(this.decreseInterval);
          }
        }, 1000);
      } else {
        this.$message.error(msg);
      }
    },
    //更新修改的资料
    async getUserNow() {
      let res =await getUserMenuByIdentity()
      
      // let res = await getUserNow();
      if (res.code == 0) {
        this.$store.dispatch("SetIdentityObj", res.data.identity);
        //更新身份信息后刷新当前页面，确保最新数据渲染
        this.$router.go(0);
        // this.form.contactName  = this.identityObj.contactName
        // this.form.contactPhone = this.identityObj.contactPhone
        // this.form.contactCard=this.identityObj.contactCard
      }
    },
    //修改银行卡号
    submitBankId() {
      this.form = {
        ...this.form,
        bankCardId: this.editFormBank.bankCardId || '',
        affiliatedBank: this.editFormBank.affiliatedBank || '',
        bankCardPhone: this.editFormBank.bankCardPhone || '',
        smsCode: this.editFormBank.smsCode || ''
      }
      this.$refs.editFormBank.validate(async (valid) => {
        if (valid) {
          const code = this.identityObj.identityTypeCode;
          // 克隆一份form
          let submitForm = { ...this.form };

          // 只在提交对象上做格式转换，不影响this.form
          if (code == '2') {
            submitForm.cardFront = this.imgInfo[0] || '';
            submitForm.cardBack = this.imgInfo[1] || '';
          } else if (code == '3') {
            submitForm.bossCardFront = this.imgInfo[0] || '';
            submitForm.bossCardBack = this.imgInfo[1] || '';
            if (code == '4' && Array.isArray(submitForm.city)) {
              submitForm.city = submitForm.city[submitForm.city.length - 1];
            }
          }

          // companyPhoto 多图
          submitForm.companyPhoto = (this.imagesInfos && this.imagesInfos.length > 0)
            ? this.imagesInfos.join(',')
            : '';

          // 处理营业执照字段，确保为图片路径字符串
          if (Array.isArray(submitForm.businessLicense) && submitForm.businessLicense.length > 0) {
            // el-upload file-list 格式，取第一个图片的 url 字段（去掉baseUrl前缀）
            const url = submitForm.businessLicense[0].url || '';
            // 提取路径部分
            const match = url.match(/ossFilePath=([^&]+)/);
            submitForm.businessLicense = match ? decodeURIComponent(match[1]) : '';
          } else if (typeof submitForm.businessLicense === 'object' && submitForm.businessLicense !== null) {
            // 兼容对象格式
            const url = submitForm.businessLicense.url || '';
            const match = url.match(/ossFilePath=([^&]+)/);
            submitForm.businessLicense = match ? decodeURIComponent(match[1]) : '';
          } else if (typeof submitForm.businessLicense !== 'string') {
            submitForm.businessLicense = '';
          }

          let params = {};
          if (code == '2') {
            params.modifyUserAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense // 直接取路径字符串
            };
          } else if (code == '3') {
            params.modifyGroupAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense
            };
          } else if (code == '4' || code == '9') {
            params.modifyCompanyAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense
            };
          }

          console.log(params, '查看params')
          // 传给后端
          let res = await changeUserInfo(params)
          if (res.code == 0) {
            this.getUserNow();
            this.$message.success(res.msg);
            this.$store.dispatch("LogOut").then(() => {
              // location.reload();
              this.$router.push({ name: "login" });
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      });
    },
    //修改联系人
    async submiteditFormPeople() {
      let params = {
            ...this.editFormPeople,
      };
      let res = await changeContract(params);
      if (res.code == 0) {
        this.flag2 = false;
        this.showChangePeople = false;
        this.getUserNow();
                this.form.contactName=this.identityObj.contactName 
        this.form.contactPhone=this.identityObj.contactPhone 
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    //修改资料
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const code = this.identityObj.identityTypeCode;
          // 克隆一份form
          let submitForm = { ...this.form };

          // 只在提交对象上做格式转换，不影响this.form
          if (code == '2') {
            submitForm.cardFront = this.imgInfo[0] || '';
            submitForm.cardBack = this.imgInfo[1] || '';
          } else if (['3', '4', '9'].includes(code)) {
            submitForm.bossCardFront = this.imgInfo[0] || '';
            submitForm.bossCardBack = this.imgInfo[1] || '';
            if (code == '4' && Array.isArray(submitForm.city)) {
              submitForm.city = submitForm.city[submitForm.city.length - 1];
            }
            else if(code=='9'){
             submitForm.bankCompanyName = submitForm.companyName;
          }
          }

          // companyPhoto 多图
          submitForm.companyPhoto = (this.imagesInfos && this.imagesInfos.length > 0)
            ? this.imagesInfos.join(',')
            : '';

          // 处理营业执照字段，确保为图片路径字符串
          if (Array.isArray(submitForm.businessLicense) && submitForm.businessLicense.length > 0) {
            // el-upload file-list 格式，取第一个图片的 url 字段（去掉baseUrl前缀）
            const url = submitForm.businessLicense[0].url || '';
            // 提取路径部分
            const match = url.match(/ossFilePath=([^&]+)/);
            submitForm.businessLicense = match ? decodeURIComponent(match[1]) : '';
          } else if (typeof submitForm.businessLicense === 'object' && submitForm.businessLicense !== null) {
            // 兼容对象格式
            const url = submitForm.businessLicense.url || '';
            const match = url.match(/ossFilePath=([^&]+)/);
            submitForm.businessLicense = match ? decodeURIComponent(match[1]) : '';
          } else if (typeof submitForm.businessLicense !== 'string') {
            submitForm.businessLicense = '';
          }

          let params = {};
          if (code == '2') {
            params.modifyUserAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense // 直接取路径字符串
            };
          } else if (code == '3') {
            params.modifyGroupAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense
            };
          } else if (code == '4' || code == '9') {
            params.modifyCompanyAuthDTO = {
              ...submitForm,
              // companyAddress: this.companyAddress,
              businessLicense: submitForm.businessLicense
            };
          }

          console.log(params, '查看params')
          // 传给后端
          let res = await changeUserInfo(params)
          if (res.code == 0) {
            this.getUserNow();
            this.$message.success(res.msg);
            this.$store.dispatch("LogOut").then(() => {
              // location.reload();
              this.$router.push({ name: "login" });
            });
          } else {
            this.$message.error(res.msg);
          }
        } else {
          this.$message.error('请先完善必填信息后再提交');
          // 滚动到第一个错误字段
          const firstErrorField = this.$el.querySelector('.is-error');
          if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    },
    //数据回显
    async echoIdentityObj() {

      const typeMap = {
        '2': 'sysUserAuth',
        '3': 'sysGroupAuth',
        '4': 'sysCompanyAuth',
        '9': 'sysCompanyAuth',
      };

      const fields = this.currentFields;
      const type = String(this.identityObj.identityTypeCode);

      // 回显表单对象
      this.form = {};

      // 1. 常规类型（2/3/4/9）优先从各自认证信息对象取值
      // 2. 其他未知类型（例如 19）直接以 identityObj 本身作为数据源，
      //    以便 'error' 配置能够正确取到 identityName / roleName / userName 等字段。
      let sourceObj = typeMap[type]
        ? (this.identityObj[typeMap[type]] || {})
        : this.identityObj;

      // 遍历所有表单字段配置
      fields.forEach(field => {
        // 如果是图片类型字段
        if (field.type === 'image') {
          // 经营场所照片（多图）特殊处理
          if (field.key === 'companyPhoto') {
            if (sourceObj[field.key]) {
              // 兼容字符串和数组，转为数组
              let imgArr = Array.isArray(sourceObj[field.key]) ? sourceObj[field.key] : sourceObj[field.key].split(',');
              this.imagesInfos = imgArr.filter(Boolean); // 只存url
              this.imagesIds = imgArr.map((img, idx) => `${field.key}_${idx}`); // 生成唯一id
              // 组装成 el-upload 需要的 file-list 数组对象
              this.form[field.key] = imgArr.filter(Boolean).map((img, idx) => ({
                name: field.label + (imgArr.length > 1 ? `_${idx + 1}` : ''),
                url: this.baseUrl + "admin/file/get?ossFilePath=" + img
              }));
            } else {
              // 没有图片则置空
              this.form[field.key] = [];
              this.imagesInfos = [];
              this.imagesIds = [];
            }
            // 其他多图字段
          } else if (field.multiple) {
            if (sourceObj[field.key]) {
              let imgArr = Array.isArray(sourceObj[field.key]) ? sourceObj[field.key] : sourceObj[field.key].split(',');
              this.form[field.key] = imgArr.filter(Boolean).map((img, idx) => ({
                name: field.label + (imgArr.length > 1 ? `_${idx + 1}` : ''),
                url: this.baseUrl + "admin/file/get?ossFilePath=" + img
              }));
            } else {
              this.form[field.key] = [];
            }
            // 个人身份证正反面特殊处理（仅 type=2 时）
          } else if (type === '2' && ['cardFront', 'cardBack'].includes(field.key) && sourceObj[field.key]) {
            this.form[field.key] = [{
              name: field.label,
              url: this.baseUrl + "admin/file/get?ossFilePath=" + sourceObj[field.key]
            }];
            // 其他图片字段（单图）
          } else if (sourceObj[field.key]) {
            // 如果该字段是字符串（单张图片的路径），则转为 el-upload 需要的数组对象格式
            if (typeof sourceObj[field.key] === 'string') {
              this.form[field.key] = [{
                name: field.label, // 图片名称显示为字段label
                url: this.baseUrl + "admin/file/get?ossFilePath=" + sourceObj[field.key] // 拼接完整图片访问地址
              }];
              // 如果该字段本身就是数组（多张图片），则逐个转为 el-upload 需要的对象格式
            } else if (Array.isArray(sourceObj[field.key])) {
              this.form[field.key] = sourceObj[field.key].map(img => ({
                name: field.label, // 图片名称显示为字段label
                url: this.baseUrl + "admin/file/get?ossFilePath=" + img // 拼接完整图片访问地址
              }));
            }
          } else {
            // 没有图片则置空
            this.form[field.key] = [];
          }
        } else {
          // 非图片字段，直接赋值，若无则设为''
          this.form[field.key] = sourceObj[field.key] ?? '';
        }
      });
      // console.log(this.form, '查看this.form')
      // 如果 typeMap 里没有该类型，确保所有字段都初始化为空字符串
      if (!typeMap[type]) {
        fields.forEach(field => {
          if (!(field.key in this.form)) {
            this.$set(this.form, field.key, '');
          }
        });
      }
      // 特殊处理双级联选择器
      if (fields.some(f => f.type === 'double-cascader')) {
        console.log(sourceObj.areaCode)
        if (sourceObj.areaCode && sourceObj.areaCode.length > 0) {
          let parentCode = sourceObj.areaCode.length > 6
            ? sourceObj.areaCode.substring(0, 6)
            : sourceObj.areaCode;
          this.value = Number(parentCode);
          let params = { parentCode };
          let res = await getXzqArr(params);
          console.log(res, '查看res');
          if (res.data && res.data.length > 0) {
            this.options2 = removeEmptyChildren(res.data, "children");
          }
          // value2 只在 areaCode 长度大于6 时赋值
          this.value2 = sourceObj.areaCode.length > 6 ? Number(sourceObj.areaCode) : '';
        } else {
          this.value = '';
          this.value2 = '';
        }
        // console.log(this.value, this.value2, '查看获取的数据')
      }
      // console.log('查看获取的sourceObj',sourceObj)
      if (type == '2') {
        // 只取图片路径，不带baseUrl
        this.imgUrl[0] = sourceObj.cardFront || '';
        this.imgUrl[1] = sourceObj.cardBack || '';
        this.imgInfo[0] = sourceObj.cardFront || '';
        this.imgInfo[1] = sourceObj.cardBack || '';
      } else if (type == '3') {
        // 集体经济组织：负责人身份证
        this.imgUrl[0] = sourceObj.bossCardFront || '';
        this.imgUrl[1] = sourceObj.bossCardBack || '';
        this.imgInfo[0] = sourceObj.bossCardFront || '';
        this.imgInfo[1] = sourceObj.bossCardBack || '';
      } else if (type == '4' || type == '9') {
        // 法人：只取图片路径，不带baseUrl
        this.imgUrl[0] = sourceObj.bossCardFront || '';
        this.imgUrl[1] = sourceObj.bossCardBack || '';
        this.imgInfo[0] = sourceObj.bossCardFront || '';
        this.imgInfo[1] = sourceObj.bossCardBack || '';
      }
      this.form
      console.log(this.form,'查看this.form')
     
    },
    async uploadYyzz(file, filelist) {
      const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isPDF = file.raw.type === "application/pdf";
      if (!isJPG && !isPDF) {
        this.$message.error("只能上传 JPG/JPEG/PNG/GIF/PDF 格式的图片或文件");
        const indexOfFile = fileList.indexOf(file);
        fileList.splice(indexOfFile, 1);
        return;
      }
      this.uploading = 1;
      let param = new FormData();
      param.append("catalog", "register");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      if (res.code == 0) {
        // 只存储为数组格式，兼容 el-upload file-list
        this.form.businessLicense = [{
          name: file.name,
          url: this.baseUrl + "admin/file/get?ossFilePath=" + res.data.url
        }];
        this.businessLicenseUrl = res.data.url;
        setTimeout(() => {
          this.uploading = 0;
          if (this.$refs.form) this.$refs.form.validateField("businessLicense");
        }, 100);
      } else {
        this.$message.error("上传失败");
        const indexOfFile = fileList.indexOf(file);
        fileList.splice(indexOfFile, 1);
        this.uploading = 0;
      }
    },
    removeYyzz: async function (file) {
      // 删除服务器上的图片
      if (this.businessLicenseUrl) {
        await this.deleteFile(this.businessLicenseUrl);
        this.businessLicenseUrl = '';
      }
      this.form.businessLicense = [];
      this.uploading = 0;
    },
    async handleChange(file, type) {
      let imgIndex = Number(type);
      let rawFile = file.raw || (file instanceof File ? file : null);
      if (!rawFile) rawFile = file;

      // 分别设置 loading
      if (this.beforeUpload(rawFile, imgIndex)) {
        if (imgIndex === 0) this.loadingFront = true;
        if (imgIndex === 1) this.loadingBack = true;
        // 删除旧图片
        if (this.imgInfo[imgIndex]) {
          await this.deleteFile(this.imgInfo[imgIndex]);
        }
        // 上传新图片
        let param = new FormData();
        param.append("catalog", "sfz");
        param.append("file", rawFile);
        let res = await uploadFile(param);
        if (res.code == 0) {
          const ossPath = res.data.url;
          console.log(ossPath,'查看osspATH')
          console.log(imgIndex,'查看imgIndex')
          this.imgInfo[imgIndex] = ossPath;
          this.imgUrl[imgIndex] = ossPath;
          console.log(this.imgInfo,this.imgUrl)

          // 根据身份类型和上传索引确定要写入 form 的字段名
          let fieldKey = '';
          const code = String(this.identityObj.identityTypeCode);
          if (code === '2') {
            fieldKey = imgIndex === 0 ? 'cardFront' : 'cardBack';
          } else if (code === '3') {
            fieldKey = imgIndex === 0 ? 'bossCardFront' : 'bossCardBack';
          } else if (code === '4') {
            fieldKey = imgIndex === 0 ? 'bossCardFront' : 'bossCardBack';
          } else if (code === '9') {
            fieldKey = imgIndex === 0 ? 'bossCardFront' : 'bossCardBack';
          }

          if (fieldKey) {
            // Element-UI 上传组件期望数组
            this.$set(this.form, fieldKey, [{
              name: file.name,
              url: this.baseUrl + 'admin/file/get?ossFilePath=' + ossPath
            }]);
          }
          console.log(this.form,'这里应该ok了')
          if (imgIndex === 0) this.loadingFront = false;
           if (imgIndex === 1) this.loadingBack = false;
        }
       
      }
      console.log(this.form,'查看this.form')

    },
    beforeUpload(file, imgIndex) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 6;
      if (!isJPG) {
        this.$message.error("上传图片为 JPG 或 PNG 格式!");
        this.imgInfo[imgIndex] = undefined;
        this.imgUrl[imgIndex] = undefined;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 6MB!");
        this.imgInfo[imgIndex] = undefined;
        this.imgUrl[imgIndex] = undefined;
      }
      return isJPG && isLt2M;
    },
    async deleteFile(url) {
      if (!url) return;
      let res = await deleteFile({ ossFilePath: url });
      if (res.code == 0 && res.data == true) {
        // 删除成功
      }
    },
    beforeUpload2(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt6M = file.size / 1024 / 1024 < 6;
      if (!isJPG) {
        this.$message.error("只能上传 JPG/JPEG/PNG/GIF 格式的图片");
      }
      if (!isLt6M) {
        this.$message.error("上传图片或文件大小不能超过 6MB");
      }
      return isJPG && isLt6M;
    },
    uploadImages(file, fileList) {
      this.uploadFileForCompanyPhoto(file, fileList);
    },
    removeImages(file) {
      let index = this.imagesIds.indexOf(file.uid);
      // 可选：this.deleteFile(this.imagesInfos[index]);
      this.imagesIds.splice(index, 1);
      this.imagesInfos.splice(index, 1);
      this.form.companyPhoto.splice(index, 1);

    },
    async uploadFileForCompanyPhoto(file, fileList) {
      let param = new FormData();
      param.append("catalog", "register");
      param.append("file", file.raw);
      let res = await uploadFile(param);
      if (res.code == 0) {
        this.imagesIds.push(file.uid);
        this.imagesInfos.push(res.data.url);
        // 回显
        if (!this.form.companyPhoto) this.form.companyPhoto = [];
        this.form.companyPhoto.push({
          name: file.name,
          url: this.baseUrl + 'admin/file/get?ossFilePath=' + res.data.url
        });
      } else {
        this.$message.error("上传失败");
        const indexOfFile = fileList.indexOf(file);
        fileList.splice(indexOfFile, 1);
      }
    },
    // 关闭修改手机弹窗时重置验证码倒计时
    resetTelCountdown() {
      // 清除定时器
      if (this.decreseInterval) {
        clearInterval(this.decreseInterval);
        this.decreseInterval = null;
      }
      // 重置计数与按钮状态
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate();
      }
      this.current = this.max;
      this.flag = false;
    },
    handleBankDialogClose() {
      // 清除可能仍在运行的倒计时定时器
      if (this.decreseInterval) {
        clearInterval(this.decreseInterval);
        this.decreseInterval = null;
      }
      // 重置倒计时&按钮状态
      this.flag2 = false;
      this.current2 = this.max;

      // 校验重置（两个弹窗可能复用同一关闭方法，需分别判空）
      if (this.$refs.editFormBank) {
        this.$refs.editFormBank.clearValidate();
      }
      if (this.$refs.editFormPeople) {
        this.$refs.editFormPeople.clearValidate();
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-form-item__content {
  text-align: left !important;
}

h3 {
  text-indent: 30px;
  margin-bottom: 60px;
}

.reset-pwd {
  text-align: left;

  // margin-top: 46px;
  .title {
    font-size: 15px;
    font-weight: 600;
  }

  .info {
    width: 600px;
    margin-left: 100px;
    text-align: center;
  }
}

.upload {
  display: flex;
  align-items: center;

  // margin-bottom: 16px;
  .upload-box {
    width: 148px;
    height: 126px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background: #fafafa;
    margin-right: 16px;
    padding: 0;
    overflow: hidden;

    /deep/.el-upload {
      width: 148px !important;
      height: 126px !important;

      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
        display: block;

        border: none;
        box-shadow: none;
        background: none;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      margin: 0;
      padding: 0;
      border: none;
      box-shadow: none;
      background: none;
    }
  }
}
</style>
